import controller from './paginator-controller';
import template from './paginator.html';

const PaginatorComponent = {
    bindings: {
        itemsPerPage: '<',
        itemListLength: '<',
        onUpdateStartingIndex: '&'
    },
    controller,
    template
};

export default PaginatorComponent;



// WEBPACK FOOTER //
// ./app/common/paginator/paginator-component.js